import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import eclosionReference from '../../../brand/eclosion-reference.png';
import styles from './Logo.module.css';
import { SYMBOL_PATH, WORDMARK_PATH } from './paths.js';
const LEGACY_SOURCE_WIDTH = 1536;
const LEGACY_SOURCE_HEIGHT = 1024;
/**
 * Logotype Éclosion, vectorisé (S1-a) à partir de la maquette Halo validée
 * (`regie/halo/DESIGN-VALIDE.md`, 17 septembre 2026). Les tracés
 * (`./paths.ts`) sont la même géométrie que `packages/ui/brand/eclosion-symbole.svg`
 * et `eclosion-lettrage.svg` (fidélité au pixel : voir `packages/ui/brand/README.md`).
 * Un seul `fill="currentColor"` : la couleur suit `--ink`, déjà thémée
 * (`packages/ui/src/tokens.css`) — plus besoin des astuces `mix-blend-mode`
 * de l'ancienne intégration PNG (voir prop `legacy`).
 */
export function Logo({ collapsed = false, title = 'Artosera', legacy = false, className, ...rest }) {
    const classes = [
        styles.logo,
        collapsed ? styles.collapsed : '',
        legacy ? styles.legacy : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');
    if (legacy) {
        return (_jsxs("span", { className: classes, role: "img", "aria-label": title, ...rest, children: [_jsx("svg", { className: styles.symbol, viewBox: "620 96 390 480", "aria-hidden": "true", children: _jsx("image", { href: eclosionReference, width: LEGACY_SOURCE_WIDTH, height: LEGACY_SOURCE_HEIGHT }) }), collapsed ? null : (_jsx("svg", { className: styles.word, viewBox: "470 590 600 125", "aria-hidden": "true", children: _jsx("image", { href: eclosionReference, width: LEGACY_SOURCE_WIDTH, height: LEGACY_SOURCE_HEIGHT }) }))] }));
    }
    return (_jsxs("span", { className: classes, role: "img", "aria-label": title, ...rest, children: [_jsx("svg", { className: styles.symbol, viewBox: "46.5 0 390 480", "aria-hidden": "true", children: _jsx("path", { fill: "currentColor", d: SYMBOL_PATH }) }), collapsed ? null : (_jsx("svg", { className: styles.word, viewBox: "0 0 600 125", "aria-hidden": "true", children: _jsx("path", { fill: "currentColor", d: WORDMARK_PATH }) }))] }));
}
//# sourceMappingURL=Logo.js.map